import { schema } from "normalizr";

export const role = new schema.Entity("roles");
